module.exports = __webpack_public_path__ + "img/vlf_varialandstk.2ad21a0.png";